import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { getToken } from "../../utils/getToken";

export const useGetDriverOrdersonAdmin = ({ id }: { id: string }) => {
  const token = getToken();

  return useQuery({
    queryKey: ["useGetDriverOrdersonAdmin", id],
    queryFn: () =>
      axiosInstance
        .get(`orders/admin/drivers/${id}/orders`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            perPage: 100,
          },
        })
        .then((res) => res.data),

    enabled: !!token,
  });
};
